import { ShelfElement } from './shelf-element';


export class ShelfSection {


    /**
     * @var
     */
    private _number: number;

    /**
     * @var
     */
    private _xPosition: number;

    /**
     * @var
     */
    private _zPosition: number;

    /**
     * @var
     */
    private _isClosed: boolean;

    /**
     * @var
     */
    private _height = 0.0;

    /**
     * @var
     */
    private _elements: ShelfElement[];

    public constructor() {
        this._elements = [];
    }

    /**
     *
     * @param ShelfElement
     */
    public addElement(shelfElement) {
        this._elements.push(shelfElement);
    }

    /**
     *
     * @param ShelfElement
     */
    public removeElement() {
        if (this._elements.length > 0) {
            const elementToRemove = this._elements.pop();
            this._height = this._height - elementToRemove.height;
            return elementToRemove;
        }
        return null;
    }


    get number(): number {
        return this._number;
    }

    set number(value: number) {
        this._number = value;
    }

    get xPosition(): number {
        return this._xPosition;
    }

    set xPosition(value: number) {
        this._xPosition = value;
    }

    get zPosition(): number {
        return this._zPosition;
    }

    set zPosition(value: number) {
        this._zPosition = value;
    }

    get isClosed(): boolean {
        return this._isClosed;
    }

    set isClosed(value: boolean) {
        this._isClosed = value;
    }

    get elements(): ShelfElement[] {
        return this._elements;
    }

    set elements(value: ShelfElement[]) {
        this._elements = value;
    }

    get height(): number {
        return this._height;
    }

    set height(value: number) {
        this._height = value;
    }
}


// WEBPACK FOOTER //
// ./src/app/shelf-section.ts